// import { ServicoHttp } from '@/modulos/comum/servico-http'
// import { ServicoHttp as ServiceHttpCallingCircle } from '@/modulos/comum/servico-http-calling-circle'
// import { ServicoUserPleni } from '@/modulos/user-pleni/servicoUserPleni'

class ApiService {
  constructor () {
    console.log('CONSTRUCT ApiService')
    // this.servicoHttp = new ServicoHttp(this)
    // this.servicoHttpCallingCircle = new ServiceHttpCallingCircle(this)

    // this.sPepPacFiles = new ServicoUserPleni('/api/pep/file/get-by-pac', this.servicoHttp)
    // this.sGetRightInfo = new ServicoUserPleni('/api/pep/atendimento/get-right-info', this.servicoHttp)
    // this.sGetSchedulePatientById = new ServicoUserPleni('/api/pep/schedule/get-id', this.servicoHttp)
    // this.sPepSaveJustifyEnterRoom = new ServicoUserPleni('/api/pep/atendimento/save-justificativa-entrar-sala', this.servicoHttp)
    // this.apiCallingCircleSetLinkAgora = new ServicoUserPleni('/solicitacao-atendimento/set-token', this.servicoHttpCallingCircle)
  }
}

export default ApiService
